import React from 'react'
import styled from 'styled-components'

const A11yNav = styled.div`
  a {
    position: absolute;
    top: -200px;
    clip: rect(1px, 1px, 1px, 1px);
    overflow: hidden;
    height: 0;
    background-color: black !important;
    color: white !important;
    z-index: 1000;
    padding: 2px 6px;

    &:focus {
      clip: auto;
      top: 0;
      overflow: visible;
      height: auto;
      outline: 0;
    }
  }
`

export default class Template extends React.PureComponent {
  render() {
    return (
      <A11yNav>
        <a href="#content" tabIndex="10">
          Jump to Main Content
        </a>
        <a href="#navigation" tabIndex="10">
          Jump to Primary Navigation
        </a>
      </A11yNav>
    )
  }
}
